// Import firebase from this module instead of the default package.
import { initializeApp } from 'firebase/app'; // Should not be used elsewhere in the project
import 'firebase/auth';
import 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

export const firebaseApp = initializeApp({
  apiKey: 'AIzaSyDS9reelGZpvrcQ4kx2TYb1g_cj1CpChpM',
  authDomain: 'glasklart-x.firebaseapp.com',
  projectId: 'glasklart-x',
  storageBucket: 'glasklart-x.appspot.com',
  messagingSenderId: '932661322525',
  appId: '1:932661322525:web:873ba42f8c436cefc7b7f4',
  measurementId: 'G-2NGLSSL3GD',
});

export const firebaseAuth = getAuth(firebaseApp);
export const firestore = getFirestore(firebaseApp);
